export default __webpack_public_path__ + "static/media/yellow_icon_with_notes.8c6ee21a.png";